package org.gstechnovos.jexonplastech.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaBars
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.gstechnovos.jexonplastech.models.Section
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.styles.LogoStyle
import org.gstechnovos.jexonplastech.styles.NavigationItemStyle
import org.gstechnovos.jexonplastech.util.Constants
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.gstechnovos.jexonplastech.util.Res
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun Header(
    onMenuClick: () -> Unit
) {

    val breakPoint = LocalBreakpoint.current

    Row(
        modifier = Modifier.fillMaxWidth(if (breakPoint > Breakpoint.MD)80.percent else 90.percent).margin(topBottom = 50.px),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        LeftSide(onMenuClick = onMenuClick)
        if (breakPoint > Breakpoint.MD) {
            RightSide()
        }
    }
}

@Composable
fun LeftSide(
    onMenuClick: () -> Unit
) {
    val breakPoint = LocalBreakpoint.current

    Row(verticalAlignment = Alignment.CenterVertically) {
        if (breakPoint <= Breakpoint.MD) {
            FaBars(
                modifier = Modifier
                    .margin(
                        right = 15.px
                    )
                    .onClick {
                        onMenuClick()
                    },
                size = IconSize.XL
            )
        }
        Image(
            src = Res.Image.LOGO, description = "logo", modifier = LogoStyle.toModifier().height(70.px).width(200.px)
        )
    }
}

@Composable
fun RightSide() {
    Row(
        modifier = Modifier.fillMaxWidth().borderRadius(50.px).backgroundColor(Theme.LighterGray.rgb).padding(20.px),
        horizontalArrangement = Arrangement.End
    ) {
        Section.entries.toTypedArray().take(6).forEach { section ->
            Link(
                modifier = NavigationItemStyle.toModifier().padding(right = 30.px), path = section.path, text = section.title
            )
        }
    }
}